import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { Modules } from "../../../constants/Module";
import { withTranslation } from "react-i18next";
function Stakeholder({ item,t }) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          {ucFirst(Modules.STAKEHOLDER)} ({typeof item?.payload?.name === 'object' ? item?.payload?.name.old : item?.payload?.name}){" "}
        </strong>
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was removed from")}{" "}
        <strong>
          t('startup') {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        by
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && ( 
        <div>
          {typeof item?.payload?.name === 'object' &&
            item?.payload?.name?.old &&
            item?.payload?.name?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Name')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.name?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.name?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.email === "object" && 
           item?.payload?.email?.old && item?.payload?.email?.new && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Email')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.email?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.email?.new}
                  </span>
                </div>
              </div>
            </div>
          )}
          {typeof item?.payload?.entity && item?.payload?.entity?.old && item?.payload?.entity?.new && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Entity')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.entity?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.entity?.new}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.group &&
            item?.payload?.group?.old &&
            item?.payload?.group?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Group')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {item?.payload?.group?.old}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {item?.payload?.group?.new}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.contactNo &&
            item?.payload?.contactNo?.old &&
            item?.payload?.contactNo?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Contact No')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {item?.payload?.contactNo?.old}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {item?.payload?.contactNo?.new}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.type &&
            item?.payload?.type?.old &&
            item?.payload?.type?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Type')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {item?.payload?.type?.old}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {item?.payload?.type?.new}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.customType &&
            item?.payload?.customType?.old &&
            item?.payload?.customType?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Custom Type')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {item?.payload?.customType?.old}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {item?.payload?.customType?.new}
                    </span>
                  </div>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
export default withTranslation()(Stakeholder);